import React, { useRef, useState } from 'react'; 
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import SearchQueryMiniList from './SearchQueryMiniList/SearchQueryMiniList';
import SearchQueryMiniSelectedList from './SearchQueryMiniSelectedList/SearchQueryMiniSelectedList';
import './styles.less';

const SearchSelector = ( { type = 'objects', failedValidation = false, initialItems = [], onChangeCallback,
    onChange, disabled = false, reorder = false, enableDisable = false, alwaysDisabledItems = [], showBrand = false,
    showType = true, disabledItemsChangeCallback, initialDisabledItems = [], showFilterDisabled = false, 
    canReorderCallback, saveReorderCallback, initalSelectedObjects, disableReorderCallback, revisionLearningObjects } ) => {
    const listLeft = useRef( null );
    const listRight = useRef( null );
    const [ selectedLeftItems, setSelectedLeftItems ] = useState( [] );
    const [ selectedRightItems, setSelectedRightItems ] = useState( [] ); 
 
    /*****************************************
     * onChange is passed from the antd form
     * item. What you pass to this function 
     * will become the form item's value prop.
     * So we trigger it here with:
     * triggerFormItemChange()
     *****************************************/

    const triggerFormItemChange = ( newItems ) => { 
        if ( onChange ) { 
            onChange( newItems ); 
            if ( onChangeCallback ) {
                onChangeCallback( newItems );
            }
        }  
    };
    
    const getLeftColumnName = () => {
        let name = 'Name';

        if ( type === 'objects' ) {
            name = 'Available Learning Objects';
        }

        if ( type === 'courses' ) {
            name = 'Available Courses';
        }

        if ( type === 'curricula' ) {
            name = 'Available Curricula';
        }

        if ( type === 'categories' ) {
            name = 'Available Categories';
        }

        return <span className={ disabled ? 'disabled' : '' }>{ name }</span>;
    };

    const getRightColumnName = () => {
        let name = 'Name';

        if ( type === 'objects' ) {
            name = 'Selected Learning Objects';
        }

        if ( type === 'courses' ) {
            name = 'Selected Courses';
        }

        if ( type === 'curricula' ) {
            name = 'Selected Curricula';
        }

        if ( type === 'categories' ) {
            name = 'Selected Categories';
        }

        return <span className={ disabled ? 'disabled' : '' }>{ name }</span>;
    };

    const getRightDisabledColumnName = () => {
        return <span className={ disabled ? 'disabled' : '' }>Disabled</span>;
    };

    const handleLeftSelectionChange = ( items ) => {
        setSelectedLeftItems( items );
    };

    const handleRightSelectionChange = ( items ) => {
        setSelectedRightItems( items );
    };

    const handleTransferRight = () => {
        const newItems = listRight.current.addItems( selectedLeftItems );
        listLeft.current.addDisabledItems( selectedLeftItems );
        listLeft.current.setSelectedItems( [] );
        triggerFormItemChange( newItems );
    };

    const handleTransferLeft = () => {
        const newItems = listRight.current.removeItems( selectedRightItems );
        listRight.current.setSelectedItems( [] );
        listLeft.current.removeDisabledItems( selectedRightItems );
        triggerFormItemChange( newItems );
    };

    const tableColumnsLeft = [
        {
            dataIndex: 'name',
            key: 'name', 
            title: getLeftColumnName(),
            sortKey: 'name',
            fixed: 'left',
        }
    ];

    const tableColumnsRight = [
        {
            dataIndex: 'name',
            key: 'name', 
            title: getRightColumnName(),
            sortKey: 'name',
            fixed: 'left',
        }
    ];

    const tableColumnsRightEnableDisable = [
        {
            dataIndex: 'name',
            key: 'name', 
            title: getRightColumnName(),
            sortKey: 'name',
            fixed: 'left',
        },
        {
            dataIndex: 'disabled',
            key: 'disabled', 
            title: getRightDisabledColumnName(),
            sortKey: 'disabled',
            width: 80
        }
    ];

    const handleDisabledItemsChange = ( items, enabledItem ) => {
        disabledItemsChangeCallback?.( items, enabledItem );

        // if ( JSON.stringify( values ) !== 
        //    JSON.stringify( form.getFieldValue( 'learningObjectIdsDisabled' ) ) ) { 
        listRight.current.moveToBottom( enabledItem );
        // }
    };

    return (  
        <div className="search-selector">
            <div className="flex-container-columns">
                <div className={ `left ${ failedValidation && 'failed-validation' }` }>
                    <SearchQueryMiniList 
                        ref={ listLeft }
                        type={ type }
                        disabled={ disabled }
                        showType={ showType }
                        tableColumns={ tableColumnsLeft }
                        initiallyDisabledItems={ initialItems }
                        alwaysDisabledItems={ alwaysDisabledItems }
                        selectItemsChangeCallback={ handleLeftSelectionChange }
                    />
                </div>
    
                <div className="middle">
                    <div>
                        <Button
                            size="small"
                            type={ selectedLeftItems.length !== 0 && 'primary' }
                            disabled={ disabled || selectedLeftItems.length === 0 }
                            style={ { marginBottom: '4px' } }
                            onClick={ handleTransferRight }
                        >
                            <RightOutlined />
                        </Button>
 
                        <Button
                            size="small" 
                            type={ selectedRightItems.length !== 0 && 'primary' }
                            disabled={ disabled || selectedRightItems.length === 0 }
                            onClick={ handleTransferLeft }
                        >
                            <LeftOutlined />
                        </Button>

                    </div>
                </div>

                <div className="right">
                    <SearchQueryMiniSelectedList
                        ref={ listRight }
                        type={ type }
                        disabled={ disabled }
                        reorder={ reorder }
                        showType={ showType }
                        showBrand={ showBrand }
                        tableColumns={ enableDisable ? tableColumnsRightEnableDisable : tableColumnsRight }    
                        initialItems={ initialItems }
                        onChange={ onChange }
                        enableDisable={ enableDisable }
                        initialDisabledItems={ initialDisabledItems }
                        selectItemsChangeCallback={ handleRightSelectionChange }
                        disabledItemsChangeCallback={ handleDisabledItemsChange }
                        triggerFormItemChangeCallback={ triggerFormItemChange }
                        canReorderCallback={ canReorderCallback }
                        saveReorderCallback={ saveReorderCallback }
                        disableReorderCallback={ disableReorderCallback }
                        initalSelectedObjects={ initalSelectedObjects }
                        revisionLearningObjects={ revisionLearningObjects }
                        showFilterDisabled={ showFilterDisabled }
                    />
                </div>
            </div>
        </div>
    );
};

export default SearchSelector;
